/**
 * Chart documentation shown behind the info icon on the Billing dashboard.
 *
 * Keys match the chart link property names in `CompanyBillingComponent`.
 */
export const CompanyBillingChartDocs = {
    gcp_cost: /* HTML */ `<p>
            Google Cloud spend over time, in the currency selected by
            <strong>Currency</strong>.
        </p>
        <p>
            <strong>Axes:</strong> X - date, bucketed by
            <strong>Date aggregation</strong>; Y - cost in the selected
            currency.
        </p>
        <p>
            <strong>What's counted:</strong> gross billing rows passing the
            filters, summed by the selected bucket.
        </p>
        <p>
            Buckets use usage-end date, not publish date; late rows can revise
            recent dates.
        </p>
        <p>
            Every sidebar filter can also split the total: cloud
            project/service/SKU (and BigQuery dataset), or business
            project/service and BI job/orchestrator attribution. Splits
            repartition the same total; they never add to it.
        </p>
        <p>
            Source: <code>bi_viz.dashboard_gcp_billing</code> in
            <code>am-bi-prod</code>; infrastructure cost with no player identity
            or validation filter.
        </p>`,
} as const;
